import { render } from "./AuthView.vue?vue&type=template&id=8a753e54&scoped=true"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=8a753e54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a753e54"]])

export default __exports__